'use client';

import { startMonitoring } from '@/lib/monitoring/client';

/**
 * Boots Bugsnag in the browser. Rendered once, from the root layout.
 *
 * The call is at module scope rather than in a `useEffect`, so importing this
 * module is enough — an error thrown while the tree is still rendering is
 * already covered. The boundaries call `startMonitoring()` themselves too, for
 * the case where this component never mounts at all.
 */
startMonitoring();

export default function MonitoringProvider() {
  return null;
}
